"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.outputWhenActiveOrSaveForLater = exports.setupAnalysis = void 0;
var browser_1 = require("./browser");
var console_1 = require("./console");
var allDomains = false;
var activeDomains = [];
var queryKeyAll = 'finn_debug';
function setupAnalysis() {
    if (typeof window !== 'undefined') {
        if (browser_1.hasConsole()) {
            var analysis_1 = function () {
                var keys = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    keys[_i] = arguments[_i];
                }
                if (keys && keys.length > 0) {
                    var flattendKeys = splitAndflatten(keys);
                    activeDomains = __spreadArrays(activeDomains, flattendKeys);
                }
                else {
                    allDomains = true;
                }
                var keepForLater = [];
                analysis_1.events.forEach(function (event) {
                    if (allDomains || activeDomains.includes(event.key)) {
                        console_1.outputToConsole.apply(void 0, __spreadArrays([event.method], event.args));
                    }
                    else {
                        keepForLater.push(event);
                    }
                });
                analysis_1.events = keepForLater;
            };
            analysis_1.events = [];
            window.analysis = window.analysis || analysis_1;
            window.analysis.events = window.analysis.events || [];
        }
        if ('URLSearchParams' in window) {
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            if (urlParams.has(queryKeyAll)) {
                var domains = urlParams.getAll(queryKeyAll);
                if (domains.length === 1) {
                    var singleValue = domains[0];
                    if (singleValue === '' ||
                        singleValue === 'true' ||
                        singleValue === '1') {
                        allDomains = true;
                    }
                    else if (singleValue === 'false' || singleValue === '0') {
                        allDomains = false;
                    }
                }
                var flatDomains = splitAndflatten(domains);
                activeDomains = __spreadArrays(flatDomains);
            }
        }
    }
}
exports.setupAnalysis = setupAnalysis;
function saveForLater(key, method) {
    var data = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        data[_i - 2] = arguments[_i];
    }
    if (typeof window !== 'undefined') {
        if (browser_1.hasConsole() && window.analysis) {
            window.analysis.events.push({
                args: __spreadArrays(data),
                key: key,
                time: Date.now(),
                method: method,
            });
        }
    }
}
function outputWhenActiveOrSaveForLater(key, method) {
    var data = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        data[_i - 2] = arguments[_i];
    }
    if (allDomains || activeDomains.includes(key)) {
        console_1.outputToConsole.apply(void 0, __spreadArrays([method], data));
    }
    else {
        saveForLater.apply(void 0, __spreadArrays([key, method], data));
    }
}
exports.outputWhenActiveOrSaveForLater = outputWhenActiveOrSaveForLater;
function splitAndflatten(items) {
    return items.reduce(function (previous, item) {
        var splitted = item.split(',');
        return previous.concat(splitted);
    }, []);
}
